import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine } from "recharts";

export default function ForecastChart({ series, metric = "m1a" }) {
  if (!series) return null;
  const past = series[`${metric}_past`] || [];
  const future = series[`${metric}_future`] || [];
  const isPct = metric === "m1a";

  // combine into single array: index -30..30 (0 = today)
  const data = [];
  past.forEach((v, i) => {
    data.push({ day: i - 30, real: v, forecast: null });
  });
  // today already in past (index 30 -> day 0)
  future.forEach((v, i) => {
    data.push({ day: i + 1, real: null, forecast: v });
  });
  // connect the two lines by putting today's real value also into forecast start
  if (data.length > 30) data[30].forecast = data[30].real;

  return (
    <div className="w-full" data-testid={`forecast-chart-${metric}`}>
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500">
          {metric === "m1a" ? "M1a (%) · Storico 30gg + Previsione 30gg" : "M1b (m³/km/gg) · Storico 30gg + Previsione 30gg"}
        </div>
      </div>
      <div className="h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 6, right: 10, left: 0, bottom: 6 }}>
            <CartesianGrid stroke="#1E293B" strokeDasharray="3 3" />
            <XAxis dataKey="day" tick={{ fill: "#64748B", fontSize: 10, fontFamily: "IBM Plex Mono" }}
              tickLine={{ stroke: "#334155" }} axisLine={{ stroke: "#334155" }}
              label={{ value: "giorni (0 = oggi)", position: "insideBottom", offset: -2, fill: "#64748B", fontSize: 9 }}
            />
            <YAxis tick={{ fill: "#64748B", fontSize: 10, fontFamily: "IBM Plex Mono" }}
              tickLine={{ stroke: "#334155" }} axisLine={{ stroke: "#334155" }}
              tickFormatter={(v) => (isPct ? `${v}%` : v)}
            />
            <Tooltip
              contentStyle={{ background: "#0a0f1c", border: "1px solid #1E293B", fontSize: 11, fontFamily: "IBM Plex Mono" }}
              formatter={(v) => (v == null ? "—" : (isPct ? `${v}%` : v))}
              labelFormatter={(d) => `Giorno ${d > 0 ? "+" : ""}${d}`}
            />
            <Legend wrapperStyle={{ fontFamily: "IBM Plex Mono", fontSize: 10, color: "#94A3B8" }} />
            <ReferenceLine x={0} stroke="#F59E0B" strokeDasharray="4 4" label={{ value: "OGGI", fill: "#F59E0B", fontSize: 9, position: "top" }} />
            <Line type="monotone" dataKey="real" name="Storico" stroke="#3EB6F0" strokeWidth={2} dot={false} isAnimationActive={false} />
            <Line type="monotone" dataKey="forecast" name="Previsione" stroke="#F59E0B" strokeWidth={2} strokeDasharray="6 4" dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
